import type { BrandTheme, PartialBrandTheme } from '../../types/BrandTheme'
import { merge } from 'theme-ui'
import { dirname } from 'path'
import { elkjoptheme } from '../elkjop/elkjop.theme'

import './theme.css'

export const elgigantentheme: BrandTheme = merge.all<
  BrandTheme,
  PartialBrandTheme
>(elkjoptheme, {
  branding: {
    brand: 'ELGIGANTEN',
    themedir: dirname(new URL(import.meta.url).pathname),
    staticDir: 'elgiganten',
    height: 32,
    learnMoreLinkWaitlist: 8031276,
    learnMoreLinkSearch: 8041928,
  },
})
export default elgigantentheme
